import ga4 from './ga4';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Navigation {
  constructor() {
    this.$dropDownToggle = document.querySelectorAll('.js-dropdown-toggle');
    this.$allDropDowns = document.querySelectorAll('.site-navigation__dropdown');
    this.$allSubNavs = document.querySelectorAll('.sub-nav');
    this.$searchToggle = document.querySelector('.js-toggle-search');
    this.$mobileNavToggle = document.querySelector('.js-toggle-mobile-nav');
    this.$siteNavigation = document.querySelector('.site-navigation');
    this.$headerNavi = document.querySelector('.header_navi');
    this.$searchForm = document.querySelector('.header__search form');
  }

  initDropDowns() {
    this.$dropDownToggle.forEach(button => {
      button.addEventListener('click', (e) => {
        const $dropDown = button.closest('.site-navigation__dropdown');
        const dropdownOpen = $dropDown.classList.contains('open');
        this.$allDropDowns.forEach(dropDown => dropDown.classList.remove('open'));
        this.$allSubNavs.forEach(subNav => subNav.style.maxHeight = null);

        if(!dropdownOpen) {
          const $subNav = $dropDown.querySelector('.sub-nav');
          if($subNav) {
            $subNav.style.maxHeight = $subNav.scrollHeight + 'px';
            $dropDown.classList.add('open');
          }
        }
      });
    });
  }

  initSearchToggle() {
    this.$searchToggle && this.$searchToggle.addEventListener('click', (e) => {
      const $toggleContainer = this.$searchToggle.closest('.header__search');      
      $toggleContainer.classList.toggle('open');
      if($toggleContainer.classList.contains('open')) {
        const $seachField = $toggleContainer.querySelector('.header__search--input');
        $seachField.focus();
      }
    });
  }

  initAnalytics() {
    if( this.searchForm ) {
      this.$searchForm.addEventListener('submit', (event) => {
        ga4.sendEvent({
          name: 'search',
          params: {
            'search_term': event?.target?.search.value
          }
        })
      });
    }
  }

  initMobileNavToggle() {
    this.$mobileNavToggle && this.$mobileNavToggle.addEventListener('click', (e) => {
      if(this.$headerNavi.classList.contains('open')) {
        enableBodyScroll(this.$headerNavi);
        this.$headerNavi.classList.remove('open');
        this.$mobileNavToggle.classList.remove('open');
      } else {
        disableBodyScroll(this.$headerNavi);
        this.$headerNavi.classList.add('open');
        this.$mobileNavToggle.classList.add('open');
      }
    });
  }

  init() {
    this.initDropDowns();
    this.initSearchToggle();
    this.initMobileNavToggle();
    this.initAnalytics();
  }
}

export default new Navigation;
